import React from 'react';
import { Card, Layout } from 'antd';
import { BlockOutlined, FormOutlined, SnippetsOutlined, ReadOutlined, UserOutlined } from '@ant-design/icons';
import { Routes } from '../../../routes';
import { PageLinkCard } from '../../../components/pageLinkCard/PageLinkCard';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import { useFeatureFlags } from '../../../featureFlags';
import { flags } from '../../../featureFlags/flags';

// NOTE: This page duplicates the "learning-content" branch of the nav menu in AppView.js.
// See the shared-nav-config TODO at the top of AppView.js — the menu, these landing pages,
// and the home cards should eventually be driven from a single source of truth.
const LearningContentNav = () => {

    const breadcrumbs = [
        { name: 'Course Studio', path: Routes.Home.buildPath() },
        { name: 'Learning Content' }
    ];

    const [ showCurricula, showResources, showILT ] =
        useFeatureFlags( [ flags.CURRICULA, flags.RESOURCES, flags.ILT_ENABLED ] );

    return (
        <Layout className="learning-content-nav-page">

            { /* Page header breadcrumbs */ }
            <Breadcrumbs crumbs={ breadcrumbs }/>

                <Card
                    className="learning-content-nav-content link-card"
                    title="Learning Content"
                >

                    <PageLinkCard
                        href={ Routes.Objects.buildPath() }
                        icon={ <BlockOutlined />  }
                        title="Learning Objects"
                        description="The building blocks of all courses."
                    />

                    <PageLinkCard
                        href={ Routes.Courses.buildPath() }
                        icon={ <FormOutlined />  }
                        title="Courses"
                        description="View all available courses or create new ones!"
                    />

                    <PageLinkCard
                        disabled={ !showCurricula }
                        href={ Routes.Curriculums.buildPath() }
                        icon={ <SnippetsOutlined />  }
                        title="Curricula"
                        description="Group courses together into curricula."
                    />

                    <PageLinkCard
                        disabled={ !showResources }
                        href={ Routes.ResourcesPage.buildPath() }
                        icon={ <ReadOutlined />  }
                        title="Resources"
                        description="Add, remove or edit resources."
                    />

                    <PageLinkCard
                        disabled={ !showILT }
                        href={ Routes.ILTPage.buildPath() }
                        icon={ <UserOutlined />  }
                        title="Instructor Led Training"
                        description="Setup and view instructor led training sessions."
                    />

                </Card>
        </Layout>
    );
};

export default LearningContentNav;
